import {
  CreatePackageCommand,
  PackageDto,
  PackagesApi,
  UpdatePackageCommand,
} from '@billing/app/api'
import { createApiClient } from '@billing/app/http-client'
import { makeObservable, observable, runInAction } from 'mobx'
import { BaseEntityStore } from './base/BaseEntityStore'

export class PackageStore extends BaseEntityStore<PackageDto> {
  fetchAll = false
  constructor() {
    super()

    makeObservable(this, { fetchAll: observable })
  }

  async load() {
    if (this.fetchAll) return

    const { data } = await createApiClient(PackagesApi).get()
    this.updateStoreItems(data)

    runInAction(() => {
      this.fetchAll = true
    })
  }

  async add(packageItem: CreatePackageCommand) {
    const { data } = await createApiClient(PackagesApi).create(packageItem)
    this.updateStoreItem({ ...packageItem, id: data, linkedToOrders: false }, data)
  }

  async update(updatePackageCommand: UpdatePackageCommand) {
    const { data } = await createApiClient(PackagesApi).update(updatePackageCommand)

    this.updateStoreItem({ ...updatePackageCommand, id: data, linkedToOrders: false }, data)
  }

  async delete(id: number) {
    await createApiClient(PackagesApi)._delete(id)
    this.deleteStoreItem(id)
  }
}
